import React, { useState } from 'react';
import { useLocale, useAssets } from 'hooks';
import { Grid, Typography } from '@material-ui/core';

import { QRReader, Button, StepContainer } from 'ui';
import { Asset } from 'hooks/useAssets/useAssets.types';
import { AssetDetails } from '../assetDetails/AssetDetails';

import { StepFormScanAndDisplayProps } from './StepFormScanAndDisplay.types';
import { useStyles } from './StepFormScanAndDisplay.styles';

export const StepFormScanAndDisplay = ({ handleRead, goToPreviousStep, goToNextStep }: StepFormScanAndDisplayProps) => {
  const classes = useStyles();
  const { formatMessage } = useLocale();
  const { getAssetById } = useAssets();
  const [asset, setAsset] = useState<Asset>();
  const [isError, setError] = useState(false);

  const handleQrRead = (data: string) => {
    handleRead(data);
    const scannedAsset = getAssetById(data);
    setAsset(scannedAsset);
    if (!scannedAsset && goToNextStep) {
      goToNextStep();
    }
  };

  const displayContent = () => {
    if (!asset) {
      return (
        <>
          <QRReader handleError={() => setError(true)} handleRead={handleQrRead} />
          {isError && (
            <Grid style={{ marginTop: 16 }} container spacing={2}>
              <Grid item xs={12}>
                <Typography className={classes.scannerError}>{formatMessage({ id: 'scanner.error' })}</Typography>
                <Button variant="contained" color="primary" onClick={goToNextStep}>
                  {formatMessage({ id: 'common.continue' })}
                </Button>
              </Grid>
            </Grid>
          )}
          {goToPreviousStep && (
            <Grid style={{ marginTop: 16 }} container spacing={2}>
              <Grid item xs={12}>
                <Button variant="outlined" color="primary" onClick={goToPreviousStep}>
                  {formatMessage({ id: 'common.back' })}
                </Button>
              </Grid>
            </Grid>
          )}
        </>
      );
    }

    return (
      <>
        <AssetDetails {...asset} />
        <Grid style={{ marginTop: 16 }} container spacing={2}>
          <Grid item xs={6}>
            <Button variant="outlined" color="primary" onClick={() => setAsset(undefined)}>
              {formatMessage({ id: 'common.back' })}
            </Button>
          </Grid>
          <Grid item xs={6}>
            <Button variant="contained" color="primary" onClick={goToNextStep}>
              {formatMessage({ id: 'common.continue' })}
            </Button>
          </Grid>
        </Grid>
      </>
    );
  };
  return (
    <StepContainer title={!asset ? formatMessage({ id: 'issue_battery.scan' }) : ''}>{displayContent()}</StepContainer>
  );
};
